export default "__VITE_ASSET__B6kD7HAj__"